import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getActions(itemId) {
        return Axios.get(
            `${process.env.BARRAMUNDI}inventory/action/${itemId}`
        ).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    getActionDetails({ itemId, actionId }) {
        return Axios.get(
            `${baseURL}inventory/action/${itemId}/${actionId}`
        ).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    getAlertTypeOptions(itemId) {
        return Axios.get(
            `${baseURL}inventory/action/action-alert-type${
                itemId ? "/" + itemId : ""
            }`
        ).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    getAssigneeTos() {
        return Axios.get(`${baseURL}inventory/action/assign-tos`).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    getActionTypes(itemId) {
        return Axios.get(
            `${baseURL}inventory/action/action-type${
                itemId ? "/" + itemId : ""
            }`
        ).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    getItemForCreateReminder(params) {
        return Axios.get(
            `${baseURL}inventory/action/reminder-create-for-item`,
            { params }
        ).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            } else {
                return [];
            }
        });
    },
    async getLetterTemplate() {
        const res = await Axios.get(`${baseURL}account/template/letter`);
        return res.data.response.resources;
    },
    async getCertificates(itemId = null) {
        const res = await Axios.get(
            `${baseURL}inventory/action/action-print${
                itemId ? "/" + itemId : ""
            }`
        );
        return res.data.response.resources;
    },
    async getCategoryWithBusiness() {
        const res = await Axios.get(
            `${baseURL}inventory/action/category-with-business`
        );
        return res.data.response.resources;
    },
    async getItemWithBusiness(params) {
        const res = await Axios.get(
            `${baseURL}inventory/filter-items-bundle-action`,
            { params }
        );
        return res.data.response.resource;
    },
    getReminderTypes(itemId = null) {
        return Axios.get(
            `${baseURL}inventory/action/reminder-options${
                itemId ? "/" + itemId : ""
            }`
        ).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            } else {
                return null;
            }
        });
    },
    getCheckItemDue(itemId) {
        return Axios.get(`${baseURL}inventory/action/check-item-due`, {
            params: { item_id: itemId }
        }).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            } else {
                return null;
            }
        });
    },
    /**
     * @method getBundleOptions
     * @description this api is used to retrieve selection of how to update bundle
     * @returns {Object}
     */
    getBundleOptions() {
        return Axios.get(
            `${process.env.BARRAMUNDI}inventory/action/bundle-options`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    async addAction(itemId, params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}inventory/action/${itemId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async updateAction({ itemId, actionId }, params) {
        let res = await Axios.put(
            `${process.env.BARRAMUNDI}inventory/action/${itemId}/${actionId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    /**
     * @method deleteAction
     * @description this api is used to delete the action with or without bundle option
     * @param {Object} params {"itemId" : ..., "actionType" : {}, "actionId" : ...}
     * @param {Object} bundleParams {"bundles_option": 1, "bundles": [bundleId]}
     * @returns {Object}
     */
    deleteAction({ itemId, actionId }, bundleParams) {
        return Axios.delete(
            `${process.env.BARRAMUNDI}inventory/action/${itemId}/${actionId}`,
            { params: bundleParams }
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data;
            }
            return null;
        });
    }
};
